import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

const { mediaQuery, spacers } = baseVariables;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  position: relative;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);

  &.scale-small {
    height: 300px;

    @media ${mediaQuery.md} {
      height: 400px;
    }

    @media ${mediaQuery.lg} {
      height: 500px;
    }
  }

  &.scale-medium {
    height: 400px;

    @media ${mediaQuery.md} {
      height: 500px;
    }

    @media ${mediaQuery.lg} {
      height: 600px;
    }
  }

  &.scale-large {
    height: 500px;

    @media ${mediaQuery.md} {
      height: 650px;
    }

    @media ${mediaQuery.lg} {
      height: 800px;
    }
  }

  .carousel-swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const SlideContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    width: 100%;
    height: 100%;
  }
`;

export const ControlsContainer = styled.div`
  position: absolute;
  inset-block-end: ${spacers?.spacers?.[4] ?? '1.5rem'};
  inset-inline-start: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};

  @media ${mediaQuery.md} {
    inset-block-end: ${spacers?.spacers?.[5] ?? '2rem'};
    gap: ${spacers?.spacers?.[3] ?? '1rem'};
  }

  @media ${mediaQuery.lg} {
    inset-block-end: 2.5rem;
    gap: ${spacers?.spacers?.[4] ?? '1.5rem'};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
  align-items: center;
  justify-content: center;

  @media ${mediaQuery.md} {
    gap: ${spacers?.spacers?.[3] ?? '1rem'};
  }

  color: var(--t-brand-fg-color, ${baseVariables.color.base20});
`;
